import { Inject, Injectable, NgZone } from '@angular/core';
import { WINDOW } from '@ng-web-apis/common';
import { DOCUMENT } from '@angular/common';
import { BehaviorSubject, map, Observable } from 'rxjs';

export interface CookieService {
  google_analytics: boolean;
  _LiveChat: boolean;
  vimeo: boolean;
}

@Injectable({
  providedIn: 'root',
})
export class AxeptioService {
  interval!: number;
  axeptioSDK: any;
  cookiesCompleted = false;

  choices$: BehaviorSubject<CookieService> = new BehaviorSubject<CookieService>(
    {
      google_analytics: false,
      _LiveChat: false,
      vimeo: false,
    }
  );

  constructor(
    @Inject(WINDOW) private window: Window,
    @Inject(DOCUMENT) private document: Document,
    private ngZone: NgZone
  ) {}

  init() {
    (this.axeptioSDK = this.window['_axcb'] || []).push((sdk) => {
      sdk.on('cookies:complete', (choices) => {
        this.choices$.next(choices);
        this.ngZone.runOutsideAngular(() => {
          setTimeout(() => {
            this.cookiesCompleted = choices.$$completed;
            this.document.body.classList.remove('cookies-complete');
            this.document.body.classList.add('cookies-complete');
          }, 1000);
        });
      });
      sdk.on('consent:saved', (choices) => {
        if (this.cookiesCompleted) {
          this.window.location.reload();
        }
      });
    });
  }

  get canPlayVimeo(): boolean {
    return this.choices$.value.vimeo;
  }

  get canPlayVimeo$(): Observable<boolean> {
    return this.choices$.pipe(map((choices) => choices.vimeo));
  }
}
